<template lang='pug'>
.fpui-package-editor-versions
  .row
    .col-xs-3
      label {{ 'fpStore.package.editor.versions.repository'|translate }}
    .col-xs-9
      fpui-input-toggle(
        :value='item.isRepo',
        :labels="{ checked: 'On', unchecked: 'Off' }"
        @input='changeRepo($event)'
        color='green'
      )
    .clearfix
  fpui-input-text(
    :placeholder='"fpStore.package.editor.versions.repository.url" | translate'
    v-if='item.isRepo',
    color='blue',
    :value='item.repository',
    @input="update('repository', $event)"
    required='required'
  )
  .git-versions(v-if='item.isRepo')
    h4 {{ 'fpStore.package.editor.versions'|translate }}
      fpui-button.pull-right.add-version(
        color="blue",
        unbordered,
        reverse,
        icon="fpui fpui-plus",
        @click="addVersion()"
      )
        | {{ 'fpStore.package.editor.versions.add'|translate }}
    .row(:key='index', v-if='!version.remove', v-for='version, index in item.versions')
      fpui-input-text.col-xs-11(:value='version.name', @input='updateVersion(index, "name", $event)')
      fpui-button.col-xs-1(
        unbordered,
        reverse,
        icon="fpui fpui-trash",
        @click="remove(index)",
        color="red"
      )
      .clearfix
  .not-git-versions(v-if='!item.isRepo')
    h4 {{ 'fpStore.package.editor.versions'|translate }}
      fpui-button.pull-right.add-version(
        color="blue",
        unbordered,
        reverse,
        icon="fpui fpui-plus",
        @click="item.versions.push({name: ''})"
      )
        | {{ 'fpStore.package.editor.versions.add'|translate }}
    .row(:key='index', v-if='!version.remove', v-for='version, index in item.versions')
      .col-xs-2.upload-version
        fpui-input-file-zone(
          :value='version.source'
          @input='updateVersion(index, "source", $event)'
          accept='application/zip,application/x-zip,application/x-zip-compressed'
        )
          i.fpui.fpui-download.text-blue.upload-icon(v-tooltip="$t('fpStore.package.editor.versions.source.upload.tooltip')")
          i.fpui.fpui-check.text-green.check-upload(v-if='version.source')
          i.fpui.fpui-remove.text-red.check-upload(v-if='version.source === null')
      .col-xs-9
        fpui-input-text(
          :value='version.name',
          @input="updateVersion(index, 'name', $event)"
        )
      .col-xs-1
        fpui-button(
          color="red",
          unbordered,
          reverse,
          icon="fpui fpui-trash",
          @click="remove(index)"
        )
      .clearfix
</template>

<script>

export default {
  props: {
    isNew: { type: Boolean, default: false },
    item: { type: Object, required: true },
    errors: { type: Object }
  },
  data () {
    return {
      saveVersions: []
    }
  },
  methods: {
    update (key, value) {
      let item = {...this.item}
      this.$set(item, key, value)
      this.$emit('input', item)
    },
    updateVersion (index, key, value) {
      let versions = this.item.versions && [...this.item.versions]
      if (!versions || versions.length === 0) return
      let version = {...versions[index]}
      this.$set(version, key, value)
      this.$set(versions, index, version)
      this.update('versions', versions)
    },
    addVersion () {
      let versions = (this.item.versions && [...this.item.versions]) || []
      versions.push({ name: '' })
      this.update('versions', versions)
    },
    changeRepo (value) {
      let tmpVersions = this.item.versions
      this.update('versions', this.saveVersions)
      this.saveVersions = tmpVersions
      this.update('isRepo', value)
    },
    remove (index) {
      this.updateVersion(index, 'remove', true)
    }
  }
}
</script>

<style lang='less'>
  .fpui-package-editor-versions {
    .fpui-input-toggle {
      line-height: 35px;
    }
    .row {
      padding-top: 5px;
      padding-bottom: 5px;
      .col-xs-3 {
        padding-left: 0;
      }
    }
    .upload-version {
      position: relative;
      text-align: center;
      cursor: pointer;
      .upload-icon {
        font-size: 25px;
      }
      .check-upload {
        position: absolute;
        transform: translateX(-50%);
        left: ~"calc(50% + 25px)";
        bottom: 0;
        font-size: 19px;
      }
    }
    .fpui-input-file-zone {
      width: 100%;
      height: inherit;
      border: none;
      position: initial;
    }
  }
</style>
